export const programInfo = {
  name: 'Mestrado em Educação Médica',
  edition: 'Terceira Edição',
  acronym: 'MEDUMED3',
  institution: 'Universidade Agostinho Neto',
  faculty: 'Faculdade de Medicina',
  center: 'Centro de Estudos Avançados em Educação e Formação Médica (CEDUMED)',
  duration: '24 meses',
  modality: 'Semi-presencial (b-learning)',
  totalVacancies: 30,
  startDate: 'Janeiro 2024',
  endDate: 'Novembro 2025',
  ects: 120,
  contactEmail: 'medumed@cedumed.ao',
  contactPhone: '923 572 487',
  coordinator: 'Dr. Carlos Tuti',
  viceCoordinator: 'Prof. Doutor Emanuel Catumbela',
  secretary: 'Mestre Evodia Tomas Zassala',
};

export const partnerUniversities = [
  {
    name: 'Universidade Agostinho Neto',
    location: 'Luanda',
    vacancies: 18,
    faculty: 'Faculdade de Medicina',
  },
  {
    name: 'Universidade Katyavala Bwila',
    location: 'Benguela',
    vacancies: 5,
    faculty: 'Faculdade de Medicina',
  },
  {
    name: 'Universidade José Eduardo dos Santos',
    location: 'Huambo',
    vacancies: 7,
    faculty: 'Faculdade de Medicina',
  },
];

export const curriculumModules = [
  {
    semester: 'I Semestre',
    modules: [
      {
        code: 'M1',
        name: 'Didática da Educação Médica I',
        credits: 5,
        hours: 25,
        topics: ['Teoria e Desenvolvimento Curricular', 'Competências e Objetivos de Aprendizagem'],
        category: 'Fundamentos',
      },
      {
        code: 'M2',
        name: 'Didática da Educação Médica II',
        credits: 5,
        hours: 25,
        topics: ['Planificação de Programas', 'Avaliação da Aprendizagem'],
        category: 'Fundamentos',
      },
      {
        code: 'M3',
        name: 'Gestão de Instituição de Educação Médica',
        credits: 5,
        hours: 25,
        topics: ['Organização e Sub-Sistemas', 'Gestão de Recursos Humanos', 'Gestão Académica'],
        category: 'Gestão',
      },
      {
        code: 'M4',
        name: 'Metodologia de Investigação Científica',
        credits: 5,
        hours: 25,
        topics: ['Conhecimento e Método Científico', 'Estrutura de Trabalho Científico'],
        category: 'Investigação',
      },
      {
        code: 'M5',
        name: 'Revisão Bibliográfica e Estatística Médica I',
        credits: 5,
        hours: 25,
        topics: ['Revisão Bibliográfica', 'Estudos Quantitativos e Qualitativos', 'Estatística Médica'],
        category: 'Investigação',
      },
      {
        code: 'M6',
        name: 'Ética na Investigação',
        credits: 5,
        hours: 25,
        topics: ['Ética e Liderança', 'Ética da Investigação', 'Bioética'],
        category: 'Ética',
      },
    ],
  },
  {
    semester: 'II Semestre',
    modules: [
      {
        code: 'M7',
        name: 'Tecnologias de Informação e Comunicação',
        credits: 5,
        hours: 25,
        topics: ['ICT e Globalização', 'Moodle e Ensino a Distância', 'Excel e PowerPoint'],
        category: 'Tecnologia',
      },
      {
        code: 'M8',
        name: 'Pesquisa de Literatura em Educação Médica',
        credits: 5,
        hours: 25,
        topics: ['Google Académico', 'PubMed', 'Scopus', 'Zotero'],
        category: 'Investigação',
      },
      {
        code: 'M9',
        name: 'Estatística Médica com SPSS',
        credits: 5,
        hours: 25,
        topics: ['SPSS I-V', 'Análise de Dados'],
        category: 'Investigação',
      },
      {
        code: 'M10',
        name: 'Tendências Mundiais em Educação Médica',
        credits: 5,
        hours: 25,
        topics: ['Declaração de Edimburgo', 'Padrões WFME', 'Educação Médica em África'],
        category: 'Contexto',
      },
      {
        code: 'M11',
        name: 'Contexto da Educação Médica em Angola I',
        credits: 5,
        hours: 25,
        topics: ['Ensino da Medicina em Angola', 'Sistema Nacional de Saúde', 'Legislação'],
        category: 'Contexto',
      },
      {
        code: 'M12',
        name: 'Contexto da Educação Médica em Angola II',
        credits: 5,
        hours: 25,
        topics: ['Medicina Pública e Privada', 'Agências Internacionais', 'Ordem dos Médicos'],
        category: 'Contexto',
      },
    ],
  },
];

export const admissionRequirements = [
  {
    id: 1,
    title: 'Licenciatura em Medicina ou área de saúde',
    description: 'Conclusão de licenciatura em Medicina ou noutra área de saúde, comprovada por diploma válido em Angola, com classificação mínima de 14 valores.',
    icon: 'ri-graduation-cap-line',
  },
  {
    id: 2,
    title: 'Proficiência em Língua Inglesa',
    description: 'Comprovativo de proficiência elementar na língua inglesa, designadamente para a leitura de textos profissionais.',
    icon: 'ri-translate-2',
  },
  {
    id: 3,
    title: 'Aptidão em Informática',
    description: 'Comprovativo de aptidão em informática na óptica do utilizador: motores de busca, gestão de e-mails, processador de texto, folhas de cálculo e bases de dados.',
    icon: 'ri-computer-line',
  },
  {
    id: 4,
    title: 'Experiência Docente (preferencial)',
    description: 'Pertencer ao quadro da carreira docente universitária ou da carreira do investigador científico constitui critério de preferência.',
    icon: 'ri-user-star-line',
  },
  {
    id: 5,
    title: 'Documentação Completa',
    description: 'Requerimento, BI/Passaporte, CV detalhado, 2 fotografias tipo passe, carta de motivação, declaração de dispensa da entidade empregadora.',
    icon: 'ri-file-list-3-line',
  },
];

export const timelineEvents = [
  {
    phase: 'Inscrições',
    date: '27 Nov - 08 Dez 2023',
    description: 'Período de submissão de candidaturas online através do formulário oficial.',
    status: 'completed',
  },
  {
    phase: 'Entrevistas de Acesso',
    date: '18 - 22 Dezembro 2023',
    description: 'Entrevistas presenciais ou virtuais para comprovar capacidades e domínio de requisitos.',
    status: 'completed',
  },
  {
    phase: 'Resultados e Matrícula',
    date: '26 Dez 2023 - 06 Jan 2024',
    description: 'Publicação dos resultados e matrícula dos admitidos nos exames de acesso.',
    status: 'completed',
  },
  {
    phase: 'I Semestre - Módulos Temáticos',
    date: '08 Jan - 05 Abril 2024',
    description: '6 módulos intensivos de contacto com suporte Moodle e Zoom.',
    status: 'completed',
  },
  {
    phase: 'II Semestre - Módulos Temáticos',
    date: '22 Abril - 28 Julho 2024',
    description: '6 módulos complementares e submissão dos ante-projetos de dissertação.',
    status: 'completed',
  },
  {
    phase: 'Inscrição à Dissertação',
    date: '02 - 06 Setembro 2024',
    description: 'Inscrição dos formandos aprovados no primeiro ano para o segundo ano de dissertação.',
    status: 'completed',
  },
  {
    phase: 'Elaboração do Projeto',
    date: '23 Set 2024 - 17 Jan 2025',
    description: 'Atividade tutorada para elaboração individual do projeto de investigação.',
    status: 'completed',
  },
  {
    phase: 'Desenvolvimento da Investigação',
    date: '03 Fev - 27 Junho 2025',
    description: 'Desenvolvimento da investigação aceite sob orientação presencial ou a distância.',
    status: 'active',
  },
  {
    phase: 'Submissão e Defesa',
    date: '28 Jul - 28 Nov 2025',
    description: 'Submissão das dissertações e realização das provas públicas de mestrado.',
    status: 'pending',
  },
];

export const fees = {
  inscription: { amount: '7.500,00', label: 'Taxa de Inscrição' },
  enrollment: { amount: '15.000,00', label: 'Taxa de Matrícula' },
  monthly: { amount: '75.000,00', label: 'Propina Mensal' },
  currency: 'Kwanzas',
};

export const objectives = [
  'Requalificar os actuais docentes de medicina e outras ciências de saúde, capacitando-os para um ensino de qualidade',
  'Qualificar novas gerações de formadores que possam satisfazer as crescentes necessidades nacionais',
  'Promover a actualização, revisão e reforma dos conteúdos e métodos de aprendizagem',
  'Desenvolver investigação e estimular o debate sobre a Educação Médica',
];

export const careerOutcomes = [
  'Ingresso ou progressão na Carreira Docente Universitária (Ciências de Saúde)',
  'Ingresso ou progressão na Carreira de Investigação (Ciências de Saúde)',
  'Gestão de instituições de formação em saúde e programas educacionais',
  'Prestação de assessoria, consultoria ou auditoria na área da Educação Médica',
];